// Simple encryption utility for localStorage data
// In production, you might want to use a more robust encryption library

const ENCRYPTION_KEY = 'roam4less_secure_key_2024'; // In production, this should be environment variable

// Simple XOR encryption (for demonstration - in production use proper encryption)
const encrypt = (text) => {
  try {
    const encoded = btoa(unescape(encodeURIComponent(text)));
    let result = '';
    for (let i = 0; i < encoded.length; i++) {
      result += String.fromCharCode(encoded.charCodeAt(i) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length));
    }
    return btoa(result);
  } catch (error) {
    console.error('Encryption error:', error);
    return text; // Fallback to plain text if encryption fails
  }
};

const decrypt = (encryptedText) => {
  try {
    const decoded = atob(encryptedText);
    let result = '';
    for (let i = 0; i < decoded.length; i++) {
      result += String.fromCharCode(decoded.charCodeAt(i) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length));
    }
    return decodeURIComponent(escape(atob(result)));
  } catch (error) {
    console.error('Decryption error:', error);
    return encryptedText; // Fallback to encrypted text if decryption fails
  }
};

// Secure localStorage wrapper
export const secureStorage = {
  setItem: (key, value) => {
    try {
      const encryptedValue = encrypt(JSON.stringify(value));
      localStorage.setItem(key, encryptedValue);
    } catch (error) {
      console.error('Error saving to secure storage:', error);
      // Fallback to regular localStorage
      localStorage.setItem(key, JSON.stringify(value));
    }
  },

  getItem: (key) => {
    try {
      const encryptedValue = localStorage.getItem(key);
      if (!encryptedValue) return null;
      
      const decryptedValue = decrypt(encryptedValue);
      return JSON.parse(decryptedValue);
    } catch (error) {
      console.error('Error reading from secure storage:', error);
      // Fallback to regular localStorage
      try {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
      } catch (fallbackError) {
        console.error('Fallback storage read error:', fallbackError);
        return null;
      }
    }
  },

  removeItem: (key) => {
    localStorage.removeItem(key);
  },

  clear: () => {
    localStorage.clear();
  }
};

export { encrypt, decrypt }; 